import { render, staticRenderFns } from "./SucceedPage.vue?vue&type=template&id=d6580f88&scoped=true&"
import script from "./SucceedPage.vue?vue&type=script&lang=js&"
export * from "./SucceedPage.vue?vue&type=script&lang=js&"
import style0 from "./SucceedPage.vue?vue&type=style&index=0&id=d6580f88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6580f88",
  null
  
)

export default component.exports